import React, { useEffect } from "react";
import useIsSignedIn from "../../hooks/useIsSignedIn";
import WorkshopList from "../WorkshopList/WorkshopList";
import Workshop from "../Workshop/Workshop";
import { useDispatch } from "react-redux";
import { firstLoad, loadCategories } from "../../state/workshopSlice";
import { Paper, Typography } from "@mui/material";
import { Box } from "@mui/system";
import style from "./ContentArea.module.css";
import mgtStyle from "../../style/mgtStyle.module.css";
import useGetCurrentUser from "../../hooks/useGetCurrentUser";
import Notifications from "./Notifications/Notifications";
import { Login } from "@microsoft/mgt-react";
import ListContainer from "../WorkshopList/ListContainer";

const ContentArea = () => {
  const dispatch = useDispatch();
  const isSignedIn = useIsSignedIn();
  const user = useGetCurrentUser();

  const doStartup = () => {
    dispatch(loadCategories());
    dispatch(firstLoad(user.mail));
  };

  useEffect(() => {
    if (isSignedIn) {
      doStartup();
    }
  }, [isSignedIn]);

  return (
    <Paper elevation={3} className={style.contentArea}>
      {isSignedIn ? (
        <>
          <Notifications />
          <Box className={style.listAndWorkshop}>
            <ListContainer />
            <Workshop />
          </Box>
        </>
      ) : (
        <>
          <Box sx={{ textAlign: "center", margin: "2rem" }}>
            <Typography sx={{ marginBottom: "2rem" }} variant="h2">
              Please sign in
            </Typography>
            <Login className={mgtStyle.login} />
          </Box>
        </>
      )}
    </Paper>
  );
};

export default ContentArea;
